import { Controller } from "@hotwired/stimulus";

// Deliberately separate from `currency-handler`, which clamps the same way but also
// reformats on blur and cannot yet cope with the currency changing. Fold these fields
// into that controller and delete this one once it handles currency switching.
export default class extends Controller {
  static values = { places: { type: Number, default: 2 } };

  clamp() {
    const [clamped] = this.element.value.match(this.pattern);
    this.element.value = clamped;
  }

  get pattern() {
    return new RegExp(`^\\d*\\.?\\d{0,${this.placesValue}}`);
  }
}
